import React, { useCallback, useState, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import cx from 'classnames';

import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';
import api from '../../services/api';

import {
    Button,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Col,
} from 'reactstrap';

import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ListGroupsPageTitle(props) {
    const { 
        heading, 
        icon, 
        subheading, 
        showCreateBtn,
        refreshCallback,
        refreshLoading,
        showHomeBtn
    } = props;
    const history = useHistory();
    const { register, handleSubmit, reset } = useForm({});
    const { toggleLoading, authenticated, changeFontSize } = useAuth();

    const [modalChangeRole, setModalChangeRole] = useState(false);
    const toggleModalChangeRole = useCallback(async () => {
        setModalChangeRole(!modalChangeRole);
    }, [setModalChangeRole, modalChangeRole]);

    // const goToCreateGroup = useCallback(async () => {
    //     history.push('/group/create');
    // }, [history]);

    const goToHome = useCallback(async () => {
        history.push('/groups');
    }, [history]);

    const userInfo = useCallback(() => {
        if (authenticated.user) {
            return authenticated.user;
        } else {
            return authenticated;
        }
    }, [authenticated]);

    const onSubmitChangeRole = useCallback(
        async ({ role }) => {
            const currentUserInfo = userInfo();
            toggleLoading(true);
            const labelRole = role;
            if (role === 'coordinator') { role = 1; }
            else if (role === 'giver') { role = 2; }
            else if (role === 'receiver') { role = 3; }
            api.patch(`/ro.team.changeRole`, {
                role: role,
                idCognito: currentUserInfo.idCognito,
            })
                .then((response) => {
                    currentUserInfo.role = labelRole;
                    localStorage.setItem(
                        '@Reachout:user',
                        JSON.stringify(currentUserInfo)
                    );
                    toast.success(`Role switched`);
                    toggleModalChangeRole();
                    reset(response);
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [toggleLoading, toggleModalChangeRole, reset, userInfo]
    );

    return (
        <div className="app-page-title">
            <div className="page-title-wrapper">
                <div className="page-title-heading">
                    <div
                        className={cx('page-title-icon rounded-circle', {
                            'd-none': false,
                        })}
                    >
                        <i className={icon} />
                    </div>
                    <div>
                        {heading}
                        <div
                            className={cx('page-title-subheading', {
                                'd-none': false,
                            })}
                        >
                            {subheading}
                        </div>
                    </div>
                </div>
                <div className="page-title-actions">
                    
                    {showCreateBtn && (
                        <Fragment>
                            <Button
                                className="mb-2 mr-2"
                                color="alternate"
                                onClick={() => changeFontSize('-')}
                                id="fontSizeDecrease"
                            >
                                A-
                            </Button>
                            <Button
                                className="mb-2 mr-2"
                                color="alternate"
                                onClick={() => changeFontSize('+')}
                                id="fontSizeIncrease"
                            >
                                A+
                            </Button>

                            <Button
                                className="mb-2 mr-2"
                                color="info"
                                onClick={toggleModalChangeRole}
                                id="changeRoleID"
                            >
                                Switch Role
                            </Button>
                            <UncontrolledTooltip
                                placement="left"
                                target={'changeRoleID'}
                            >
                                Switch your role
                            </UncontrolledTooltip>
                            
                            {/* // {userInfo().role === 'coordinator' && (
                            //     <Fragment>
                            //         <Button
                            //             className="mb-2 mr-2"
                            //             color="primary"
                            //             onClick={goToCreateGroup}
                            //             id="createAGroupId"
                            //         >
                            //             Create group
                            //         </Button>
                            //         <UncontrolledTooltip
                            //             placement="bottom"
                            //             target={'createAGroupId'}
                            //         >
                            //             Create a new Group
                            //         </UncontrolledTooltip>
                            //     </Fragment>
                            // )} */}

                        <Button 
                            className="mb-2 mr-2 btn-icon btn-icon-only" 
                            color="secondary" 
                            onClick={refreshCallback}
                            disabled={refreshLoading}
                            id="refreshId"
                        >
                            <FontAwesomeIcon spin={refreshLoading} icon={faSync} size="1x"/>
                        </Button>
                        <UncontrolledTooltip 
                            placement="bottom" 
                            target="refreshId"
                        >
                            Refresh List
                        </UncontrolledTooltip>
                            
                            <Modal
                                isOpen={modalChangeRole}
                                toggle={toggleModalChangeRole}
                            >
                                <ModalHeader toggle={toggleModalChangeRole}>
                                    Switch Role
                                </ModalHeader>
                                <ModalBody>
                                    <Form>
                                        <FormGroup row>
                                            <Label for="role" sm={2}>
                                                Choose
                                            </Label>
                                            <Col sm={10}>
                                                <select
                                                    name="role"
                                                    id="role"
                                                    ref={register}
                                                    className="form-control"
                                                    defaultValue={userInfo().role}
                                                >
                                                    <option value="coordinator">
                                                        Coordinator
                                                    </option>
                                                    <option value="giver">
                                                        Volunteer
                                                    </option>
                                                    <option value="receiver">
                                                        Senior
                                                    </option>
                                                </select>
                                            </Col>
                                        </FormGroup>
                                        <div className="text-center">
                                            <Button
                                                className="btn-wide mb-2 mr-2"
                                                size="md"
                                                color="success"
                                                onClick={handleSubmit(
                                                    onSubmitChangeRole
                                                )}
                                            >
                                                OK
                                            </Button>

                                            <Button
                                                className="btn-wide mb-2 mr-2"
                                                size="md"
                                                color="danger"
                                                onClick={toggleModalChangeRole}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </Form>
                                </ModalBody>
                            </Modal>
                        </Fragment>
                    )}

                    {showHomeBtn && showHomeBtn === true && (
                        <Fragment>
                            <Button
                                className="mb-2 mr-2"
                                color="primary"
                                onClick={goToHome}
                                id="homeId"
                            >
                                Home
                            </Button>
                            <UncontrolledTooltip
                                placement="bottom"
                                target={'homeId'}
                            >
                                Go to Home
                            </UncontrolledTooltip>
                        </Fragment>
                    )}

                </div>
            </div>
        </div>
    );
}
